import {startTransition, useEffect} from 'react';

/**
 * Use this to do an effect outside Suspense Boundaries without breaking their ongoing hydration.
 */
export const useStartTransitionEffect = (callback: () => void) => {
  useEffect(() => {
    startTransition(callback);
  }, [callback]);
};
